export default "__VITE_ASSET__CCfmceN6__"